import type { ComponentType } from 'react';
import { StructuredText, Image } from 'react-datocms';
import { FlexRow, FlexCol } from '@zopauk/react-components';
import type { Document } from 'datocms-structured-text-utils';
import type { HomeHeroFragment } from '@/utils/dato/generated';
import { customNodeRules, renderBlock } from '@/components/structuredText';
import { HorizontalSwoosh, VerticalSwoosh, Container, NavItems, NavCard, Content, Media, Hero } from './styles';

const HomeHero: ComponentType<HomeHeroFragment> = ({ homeHeroContent, backupImage, navItems }) => (
  <>
    <Hero className="bg-tertiary">
      <Media>
        {backupImage?.responsiveImage ? (
          <Image data={backupImage.responsiveImage} objectPosition="50% 50%" objectFit="cover" layout="fill" sizes="(max-width: 2000px) 100vw, 2000px" priority />
        ) : null}

        <HorizontalSwoosh className="fill-tertiary" viewBox="0 0 1256 144">
          <path d="M.062 143.393h1255.782v-33.861C1158.675 40.152 1035.237 3.858 885.53.65 660.97-4.163 360.307 85.622 199.766 118.182 92.74 139.89 26.171 141.683.062 123.565v19.828Z" />
        </HorizontalSwoosh>
        <VerticalSwoosh className="fill-tertiary" viewBox="0 0 97 551">
          <path d="M61.38 23.727C167.022 192.805.217 487.724 39.053 551H0V.027L46.116 0 61.38 23.727z" />
        </VerticalSwoosh>
      </Media>
      <Content>
        {homeHeroContent ? (
          <StructuredText
            data={{ value: homeHeroContent.value as Document, blocks: homeHeroContent?.homeHeroBlocks }}
            customNodeRules={customNodeRules}
            renderBlock={renderBlock}
          />
        ) : null}
      </Content>
    </Hero>

    <Container>
      <NavItems className="bg-base-100">
        <FlexRow justify="center" align="stretch">
          {navItems.map(({ content, id }) =>
            content ? (
              <FlexCol className="column" key={id} xl={3} s={6}>
                <NavCard className="card mb-4 px-5 pt-5 prose lg:prose-lg prose-p:mt-0">
                  <StructuredText
                    data={{ value: content.value as Document, blocks: content.navItemsBlocks }}
                    customNodeRules={customNodeRules}
                    renderBlock={renderBlock}
                  />
                </NavCard>
              </FlexCol>
            ) : null,
          )}
        </FlexRow>
      </NavItems>
    </Container>
  </>
);

export default HomeHero;
